<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename"><span class="c8-titlename__text">大小走势</span></div>
      </div>
      <div class="content-8__titlebar__right">
        <LotteryDateFilterTab
          @updateForm="updateForm"
        />
      </div>
    </div>

    <Loading v-if="isLoading" />
    <div v-if="trendList.length > 0 && !isLoading">

      <LotteryPresentSelector @changePresent="changePresent" />
      <div class="content-8__content">
        <table draw-root style="position:relative" class="even-color">
          <!-- 大小走勢 -->
          <thead>
            <tr v-if="lotteryType == 'k3'">
              <th rowspan="2">期号</th>
              <th rowspan="2">开奖号码</th>
              <th colspan="6">开奖号码分布</th>
              <th colspan="2">百位</th>
              <th colspan="2">十位</th>
              <th colspan="2">个位</th>
              <th colspan="4">大小比走势</th>
              <th colspan="4">大数个数</th>
              <th colspan="4">小数个数</th>
            </tr>
            <tr v-if="lotteryType == 'kl10'">
              <th rowspan="2">期号</th>
              <th rowspan="2">开奖号码</th>
              <th colspan="2">第一位</th>
              <th colspan="2">第二位</th>
              <th colspan="2">第三位</th>
              <th colspan="2">第四位</th>
              <th colspan="2">第五位</th>
              <th colspan="2">第六位</th>
              <th colspan="2">第七位</th>
              <th colspan="2">第八位</th>
              <th colspan="9">大小比走势</th>
            </tr>
            <tr>
              <th
                v-for="(num, index) in numList"
                :key="`num-${num.key}-${index}`"
                v-text="num.label"
              ></th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(trendItem,trendIndex) in trendList"
              :key="`trend-${trendItem.period}`"
              :class="{ 'tr-bottom-border': presentLineDivided && !((trendIndex + 1) % 5) }"
            >
              <td>
                <span v-text="trendItem.period"></span>
              </td>
              <td>
                <div class="continuous-text">
                  <span
                    v-for="(ball, ballIndex) in trendItem.balls"
                    :key="`trend-${trendItem.period}-${ballIndex}`"
                    class="continuous-text__text red"
                    v-text="`${ball} `"
                  ></span>
                </div>
              </td>
              <td
                v-for="{ key: numKey } in numList"
                :key="`num-${numKey}`"
                :set="item = trendItem.missing[currentHm][numKey] /* for shorten html */"
                :class="{
                  'bg-col': (trendItem.missing[currentHm][numKey].drawType === 'number' || trendItem.missing[currentHm][numKey].drawType === 'hmDaXiaoXiaoCount' || trendItem.missing[currentHm][numKey].drawType === 'hmDaXiaoDaCount'),
                  'yiloufc': presentLineMissingLayer && trendItem.missing[currentHm][numKey].isMissingLayer,
                  'bg-orange': trendItem.missing[currentHm][numKey].isOrange,
                  'bg-blue': trendItem.missing[currentHm][numKey].isBlue,
                  'bg-red': trendItem.missing[currentHm][numKey].isRed,
                  'isDraw': trendItem.missing[currentHm][numKey].isDraw
                }"
              >
                <div v-if="item.drawType === 'number' || item.drawType === 'hmDaXiaoXiaoCount' || item.drawType === 'hmDaXiaoDaCount'" class="tableballbox">
                  <div class="tableballbox__item">
                    <div class="ball circle  size-middle" :class="{'color--blue':trendItem.missing[currentHm][numKey].isDraw}">
                      <span
                        v-show="item.isDraw || presentMissing"
                        class="ball__number"
                        v-bind="item.drawMap"
                        v-text="item.label"
                      ></span>
                      <div v-if="item.drawType === 'number' && trendItem.missing[currentHm][numKey].isDraw && checkRepeat(trendItem.balls)[item.label] > 1" class="ball__subnumber">
                        <span class="ball__subnumber__text">{{ checkRepeat(trendItem.balls)[item.label] }}</span>
                        <s></s>
                      </div>
                    </div>
                  </div>
                </div>
                <span
                  v-else
                  v-show="item.isDraw || presentMissing"
                  v-bind="item.drawMap"
                  v-text="item.label"
                ></span>
              </td>
            </tr>
          </tbody>

          <!-- 数据统计 -->
          <thead statistic-dom>
            <tr v-if="lotteryType == 'k3'">
              <th colspan="2" rowspan="2">数据统计 <statisticTip /></th>
              <th colspan="6">开奖号码分布</th>
              <th colspan="2">百位</th>
              <th colspan="2">十位</th>
              <th colspan="2">个位</th>
              <th colspan="4">大小比走势</th>
              <th colspan="4">大数个数</th>
              <th colspan="4">小数个数</th>
            </tr>
            <tr v-if="lotteryType == 'kl10'">
              <th colspan="2" rowspan="2">数据统计 <statisticTip /></th>
              <th colspan="2">第一位</th>
              <th colspan="2">第二位</th>
              <th colspan="2">第三位</th>
              <th colspan="2">第四位</th>
              <th colspan="2">第五位</th>
              <th colspan="2">第六位</th>
              <th colspan="2">第七位</th>
              <th colspan="2">第八位</th>
              <th colspan="9">大小比走势</th>
            </tr>
            <tr>
              <th
                v-for="(num, index) in numList"
                :key="`num-${num.key}-${index}`"
                v-text="num.label"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="statisticItem in statisticList"
              :key="`statistic-${statisticItem.statisticType}`"
            >
              <td colspan="2" v-text="statisticItem.label"></td>
              <td
                v-for="(num, index) in numList"
                :key="`statistic-num-${num.key}-${index}`"
                v-text="statisticItem.data[currentHm][num.key]"
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <NoData v-if="trendList.length === 0 && !isLoading" />

  </div>
</template>

<script>
import {
  commonTrendMethods_web,
  drawTrendCanvas,

  basicNumList,
  basicHmList,
  numList,
  hmList,
  presentSelectorComputedVariable
} from '@/utils/flyc-temp/lotteryLib'
import LotteryPresentSelector from '@/components/web/common/LotteryPresentSelector'
import LotteryDateFilterTab from '@/components/web/pages/trend/LotteryDateFilterTab'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
import statisticTip from '@/components/web/common/statisticTip'
// k3, kl10

export default {
  name: 'WebDaXiaoZouShih', // 大小走勢
  components: {
    LotteryPresentSelector,
    LotteryDateFilterTab,
    Loading,
    NoData,
    statisticTip
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      lotteryCode: this.$route.params.lottery_code,

      // 組出這個頁面會用到的api
      trendTypes: ['numberTrend', 'hmDaXiao'],

      form: {
        count: 30
      },

      trendList: [],
      currentHm: 'all',

      statisticSort: ['appearCount', 'avgMissing', 'now', 'biggestContinue', 'biggestMissing'],
      statisticList: [],
      present: {
        presentMissing: false,
        presentLine: false,
        presentLineDivided: false,
        presentLineMissingLayer: false
      },
      isLoading: true
    }
  },
  computed: {
    ...basicNumList,
    ...basicHmList,
    ...hmList,
    ...numList, // TODO: 這裡的numList 會不會其實和api 一樣放個兩層的會比較好?
    ...presentSelectorComputedVariable,
    // 用來畫canvas 的key
    lineArray() {
      let list = []
      if (this.lotteryType === 'k3') {
        list = ['hmDaXiaoDaCount', 'hmDaXiaoXiaoCount']
      }
      if (this.lotteryType === 'kl10') {
        list = (new Array(8)).fill().map((nothing, index) => (`hm${index + 1}`))
        list.push('hmDaXiaoRatio')
      }
      return list
    }
  },
  watch: {
    currentHm(currentHm) {
      this.removeMultipleTrendCanvas()
      if (this.presentLine) {
        this.drawMultiTrendCanvas()
      }
    },

    presentLine(presentLine) {
      if (presentLine) {
        this.drawMultiTrendCanvas()
        return
      }
      this.removeMultipleTrendCanvas()
    }
  },
  async created() {
    await this.getTrendData()
    this.isLoading = false
    if (this.trendList.length && this.presentLine) this.drawMultiTrendCanvas()
  },
  mounted() {
    window.vm = this
  },
  updated() {
    this.initLazyLoading()
  },
  methods: {
    checkRepeat(array) {
      const counts = {}
      array.forEach(function(x) { counts[x] = (counts[x] || 0) + 1 })
      return counts
    },
    ...commonTrendMethods_web,
    ...drawTrendCanvas
  }
}
</script>
